interface MetaTag {
  name: string
  content: string
}

interface LinkTag {
  rel: string
  href: string
  as?: string
  crossOrigin?: string
  fetchPriority?: 'high' | 'low' | 'auto'
}

/** Mockup de los dos tomos. Secundario en el hero. */
export const HERO_IMAGE_URL =
  'https://cdn.magicpatterns.com/uploads/84bHSstEKt3S7Lne1EoH4j/mOCKUP_HERO_LANDING.png'

/** Cookie abierta del hero — es el elemento LCP. Igual a STUFFED_IMAGE. */
export const HERO_COOKIE_URL =
  'https://cdn.magicpatterns.com/patterns/generated-images/649576e7-f156-451a-8db3-593156a8113a.jpg'

const PAGE_TITLE = '100 New York Cookies — Aprendé a prepararlas y a ofrecerlas'

const META_TAGS: MetaTag[] = [
  { name: 'facebook-domain-verification', content: 'vlgvuhfbincjf8k22klsbsto3ag0az' },
  {
    name: 'description',
    content:
      'Aprendé a preparar New York Cookies gruesas, rellenas y premium con 100 recetas paso a paso en 2 tomos digitales + 5 bonos. Empezá desde tu cocina por US$ 8,99.',
  },
]

const LINK_TAGS: LinkTag[] = [
  // Warm up the font + image origins before the CSS/image requests are made.
  { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
  { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossOrigin: 'anonymous' },
  { rel: 'preconnect', href: 'https://cdn.magicpatterns.com' },
  // Discover the LCP image as early as possible, at high priority.
  { rel: 'preload', href: HERO_COOKIE_URL, as: 'image', fetchPriority: 'high' },
]

/**
 * Inserts global <meta> and resource-hint <link> tags into <head> once.
 * Existing tags are never duplicated.
 */
export function initHeadMeta(): void {
  if (typeof document === 'undefined') return

  document.title = PAGE_TITLE

  META_TAGS.forEach(({ name, content }) => {
    if (document.querySelector(`meta[name="${name}"]`)) return

    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  })

  LINK_TAGS.forEach(({ rel, href, as, crossOrigin, fetchPriority }) => {
    if (document.querySelector(`link[rel="${rel}"][href="${href}"]`)) return

    const link = document.createElement('link')
    link.rel = rel
    link.href = href
    if (as) link.as = as
    if (crossOrigin) link.crossOrigin = crossOrigin
    if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority)
    document.head.appendChild(link)
  })
}
